import styled from 'styled-components';

export const NavbarComponentWrapper = styled.div`
`;
